module.exports = __webpack_public_path__ + "static/img/female-bg-id.61e214ed.png";